import React from 'react';
import {v4 as uuidv4} from 'uuid';
import AppBar from '@mui/material/AppBar';
import AppRoutes from './Routes.jsx';
import Toolbar from '@mui/material/Toolbar';
import { t } from '../services';

import toolbarStyles from './OdeevBrowser.module.styl';
import { LanguageSelector } from '../widgets/LanguageSelector';
import { Window } from '../windowing/Window';
import { WindowLayer } from '../windowing/WindowLayer';
import { WindowManager } from '../windowing/WindowManager';

import { WelcomePage } from '@src/pages/WelcomePage';
import { createBrowserComponent } from './Browser';
import { ApplicationHeader } from "@src/ApplicationHeader";

const displayWelcomePage = () => (gui) => {
  const uuid = uuidv4();

  return {
    uuid,
    view: () => (
      <div key={uuid} style={{height: '100%'}}>
        <WelcomePage gui={gui}/>
      </div>
    )
  };
};

const HOME_ENTRY = {
  label: 'Home',
  path: '/',
  do: displayWelcomePage()
};

export class OdeevBrowser extends createBrowserComponent() {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
    };
  }

  goHome = () => {
    window.history.pushState({}, "", "/");
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  render() {
    const Navigator = this.props.navigator;

    return (
      <WindowManager>
        <div className={toolbarStyles.shell}>
          <Window layer={WindowLayer.CHROME} asChild>
            <AppBar position="static" className={toolbarStyles.appBar}>
              <Toolbar className={toolbarStyles.toolbar}>

                <div className={toolbarStyles.leftActions}>
                  <button
                    type="button"
                    className={toolbarStyles.logoButton}
                    onClick={this.goHome}
                    title={t`Home`}
                    aria-label={t`Home`}>
                    <img
                      src="/assets/public/logo.png"
                      alt={t`Home`}
                      className={toolbarStyles.logo}
                    />
                  </button>
                </div>

                <div className={toolbarStyles.centerSpace}>
                  <ApplicationHeader gui={this} />
                </div>

                <div className={toolbarStyles.rightActions}>
                  <div className={toolbarStyles.languageSelector}>
                    <LanguageSelector languages={this.props.languages}/>
                  </div>
                </div>

              </Toolbar>
            </AppBar>
          </Window>

          <Window
            layer={WindowLayer.CONTENT}
            className={toolbarStyles.content}
          >
            {Navigator && <Navigator gui={this} session={this.props.session} />}
            <AppRoutes gui={this} />
            {this.buildDesktop()}
          </Window>
        </div>
      </WindowManager>
    );
  }
}
